exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rules-art{min-height:100%;background:#fff;overflow-x:hidden}.rules-art .title{line-height:24px}.rules-art .content{line-height:20px;color:#5d5d5d;font-size:.34667rem;padding-bottom:2px}.rules-art .weui_cell.no-line:before{display:none}.rules-art .fc-black{color:#000}.rules-art .fs15{font-size:15px}", ""]);

// exports
